import { render, staticRenderFns } from "./Dmp.vue?vue&type=template&id=0a9f6cbf&scoped=true"
import script from "./Dmp.vue?vue&type=script&lang=ts"
export * from "./Dmp.vue?vue&type=script&lang=ts"
import style0 from "./Dmp.vue?vue&type=style&index=0&id=0a9f6cbf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9f6cbf",
  null
  
)

export default component.exports